export const numberWithCommas = (
  x: number | string,
  isCurrencyDecimal?: boolean,
) => {
  const [preDecimal, postDecimal] = x.toString().split('.')
  let manualDecimals = null
  if (isCurrencyDecimal && !postDecimal) {
    manualDecimals = '00'
  }
  if (postDecimal && postDecimal.length === 1 && isCurrencyDecimal) {
    manualDecimals = postDecimal + '0'
  }
  return `${preDecimal.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${
    postDecimal || isCurrencyDecimal
      ? `.${
          isCurrencyDecimal && typeof manualDecimals === 'string'
            ? manualDecimals
            : postDecimal
        }`
      : ''
  }`
}
